import { Marker, GoogleMap, LoadScript } from "@react-google-maps/api"
import config from "../../../../../application/config/config";
import axios from "axios";

function CustomMap(props) {

  const containerStyle = {
    width: '100%',
    height: '400px',
  };

  const handleMarkerDragEnd = async (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();

    const addressInfo = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${config.gmaps_key}`).then((resp) => {
      const data = resp.data.results;

      return {
        address_number: data[0].address_components[0]?.long_name,
        street_name: data[0].address_components[1]?.long_name,
        district: data[0].address_components[2]?.long_name,
        city: data[0].address_components[3]?.long_name,
        state: data[0].address_components[4]?.long_name,
        zipcode: data[0].address_components[6]?.long_name,
      }
    })

    props.setMarkerPosition({ lat, lng, addressInfo })
  };

  return (
    <LoadScript googleMapsApiKey={config.gmaps_key}>
      <GoogleMap mapContainerStyle={containerStyle} center={props.markerPosition} zoom={17}>
        <Marker
          position={props.markerPosition}
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
        />
      </GoogleMap>
    </LoadScript>
  );
}

export default CustomMap;